import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { ROLE_LABEL } from "@/user/dashboards.config";
import { userApi } from "@/user/api";

export default function Profile() {
    const { user, company } = useOutletContext();
    const [activity, setActivity] = useState([]);

    useEffect(() => {
        userApi
            .get("/user/activity")
            .then((r) => setActivity(r.data || []))
            .catch(() => {});
    }, []);

    return (
        <div data-testid="profile-page">
            <div className="max-w-3xl">
                <div className="inline-flex items-center gap-3 text-[11px] font-semibold tracking-[0.22em] uppercase text-neutral-500">
                    <span className="h-px w-6 bg-neutral-300" />
                    Profile
                </div>
                <h1 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-black">
                    {user.name}
                </h1>
                <p className="mt-3 text-[14px] text-neutral-600">{user.email}</p>
            </div>

            <div className="mt-8 grid lg:grid-cols-[1.2fr_1fr] gap-5">
                <div className="glass rounded-3xl p-6 sm:p-8">
                    <div className="text-[10px] font-semibold tracking-[0.22em] uppercase text-violet-600">
                        Identity
                    </div>
                    <dl className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 text-[13.5px]">
                        <Row k="Name" v={user.name} />
                        <Row k="Email" v={user.email} />
                        <Row k="Phone" v={user.phone || "—"} />
                        <Row k="Company" v={company?.name || "—"} />
                        <Row k="Role" v={ROLE_LABEL[user.role] || user.role} />
                        <Row k="Department" v={user.department || "—"} />
                        <Row k="Status" v={user.status} />
                        <Row k="Last Login" v={user.last_login ? new Date(user.last_login).toLocaleString() : "—"} />
                    </dl>
                </div>
                <div className="glass rounded-3xl p-6 sm:p-8">
                    <div className="text-[10px] font-semibold tracking-[0.22em] uppercase text-violet-600">
                        Recent Activity
                    </div>
                    <ul className="mt-4 divide-y divide-black/[0.05]">
                        {(activity || []).slice(0, 8).map((a) => (
                            <li key={a.id} className="py-3 flex items-center justify-between gap-3 text-sm">
                                <div className="min-w-0">
                                    <div className="font-medium text-black truncate">
                                        {String(a.action || "action").replace(/_/g, " ")}
                                    </div>
                                    <div className="text-[12px] text-neutral-500 truncate">
                                        {a.target || "—"}
                                    </div>
                                </div>
                                <span className="text-[11px] text-neutral-400">
                                    {a.timestamp ? new Date(a.timestamp).toLocaleString() : ""}
                                </span>
                            </li>
                        ))}
                        {(!activity || activity.length === 0) && (
                            <li className="py-3 text-sm text-neutral-500">
                                No activity yet.
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
}

function Row({ k, v }) {
    return (
        <div>
            <div className="text-[10.5px] font-semibold tracking-[0.16em] uppercase text-neutral-500">{k}</div>
            <div className="mt-1 text-[14px] text-black">{v || "—"}</div>
        </div>
    );
}
